import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Marker from '@/components/Marker'
import Markerinfo from '@/components/Markerinfo'
import Rewardlist from '@/components/Rewardlist'
import Ratings from '@/components/Ratings'
import Ratingsform from '@/components/Ratingsform'
import Mine from '@/components/Mine'
import Wrong from '@/components/Wrong'
import Collection from '@/components/Collection'
import Profile from '@/components/Profile'
import Compensate from '@/components/Compensate'
import Rewarddata from '@/components/Rewarddata'
import Orders from '@/components/Orders'
import Distribution from '@/components/Distribution'
import Drawmoney from '@/components/Drawmoney'
import Qcode2 from '@/components/Qcode2'
import Qcode1 from '@/components/Qcode1'
import Withdraw from '@/components/Withdraw'
import Commission from '@/components/Commission'
import Dorder from '@/components/Dorder'
import Team from '@/components/Team'
import Learn from '@/components/Learn'
import Chapter from '@/components/Chapter'
import Fee from '@/components/Fee'
import Subjectlist from '@/components/Subjectlist'
import Result from '@/components/Result'
import Subjectlistresult from '@/components/Subjectlistresult'
import Vip from '@/components/Vip'
import Corder from '@/components/Corder'
import Videodetail from '@/components/Videodetail'
import Poster from '@/components/Poster'
import Yuyue from '@/components/Yuyue'
import News from '@/components/News'
import Prize from '@/components/Prize'
import Newsinfo from '@/components/Newsinfo'
import Paiche from '@/components/Paiche'
import Posterset from '@/components/Posterset'
import Posterdown from '@/components/Posterdown'
import Addprize from '@/components/Addprize'
import Videovip from '@/components/Videovip'
import Payresult from '@/components/Payresult'
import Signup from '@/components/Signup'
import Dg from '@/components/Dg'
import Prizelist from '@/components/Prizelist'
import Prizeuser from '@/components/Prizeuser'
import Prizeinfo from '@/components/Prizeinfo'
import Ds from '@/components/Ds'
import Dgpay from '@/components/Dgpay'
import Video from '@/components/Video'
import Video1 from '@/components/Video1'
import Contact from '@/components/Contact'
import Share from '@/components/Share'
import Bindinginfo from '@/components/Bindinginfo'
import Process from '@/components/Process'
import Videocourse from '@/components/Videocourse'
import Integral from '@/components/Integral'
import Detailjx from '@/components/Detailjx'
import Contractschool from '@/components/Contractschool'
import Map from '@/components/Map'
import Shopdetail from '@/components/Shopdetail'
import Feenew from '@/components/Feenew'
import Indexnew from '@/components/Indexnew'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
	  {
      path: '/mine',
      name: 'Mine',
      component: Mine,
	  meta: {
        keepAlive: true,
		showNav:true
      }
    },
    {
      path: '/',
      name: 'Index',
      component: Index,
	  meta: {
        keepAlive: true,
		showNav:true,
		allowBack:false
      }
    },
    {
      path: '/indexnew',
      name: 'Indexnew',
      component: Indexnew,
	  meta: {
        keepAlive: true,
		showNav:true,
		allowBack:false
      }
    },

	{
      path: '/marker',
      name: 'Marker',
      component: Marker
    },
	{
      path: '/markerinfo',
      name: 'Markerinfo',
      component: Markerinfo,
	  meta: {
        keepAlive: true
      }
    },
	{
      path: '/rewardlist',
      name: 'Rewardlist',
      component: Rewardlist
    },
	{
      path: '/ratings',
      name: 'Ratings',
      component: Ratings,
	  meta: {
        keepAlive: true,
		showNav:true
      }
    },
	{
      path: '/ratingsform',
      name: 'Ratingsform',
      component: Ratingsform
    },
	{
      path: '/wrong',
      name: 'Wrong',
      component: Wrong
    },
	{
      path: '/collection',
      name: 'Collection',
      component: Collection
    },
	{
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
	{
      path: '/compensate',
      name: 'Compensate',
      component: Compensate
    },
	{
      path: '/rewarddata',
      name: 'Rewarddata',
      component: Rewarddata
    },
	{
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
	{
      path: '/distribution',
      name: 'Distribution',
      component: Distribution
    },
	{
      path: '/drawmoney',
      name: 'Drawmoney',
      component: Drawmoney
    },
	{
      path: '/qcode2',
      name: 'Qcode2',
      component: Qcode2
    },
	{
      path: '/qcode1',
      name: 'Qcode1',
      component: Qcode1
    },
	{
      path: '/withdraw',
      name: 'Withdraw',
      component: Withdraw
    },
	{
      path: '/commission',
      name: 'Commission',
      component: Commission
    },
	{
      path: '/dorder',
      name: 'Dorder',
      component: Dorder
    },
	{
      path: '/team',
      name: 'Team',
      component: Team
    },
	{
      path: '/learn',
      name: 'Learn',
      component: Learn
    },
	{
      path: '/chapter',
      name: 'Chapter',
      component: Chapter
    },
	{
      path: '/fee',
      name: 'Fee',
      component: Fee,
	  meta: {
		keepAlive: true,

      }
    },
	{
      path: '/feenew',
      name: 'Feenew',
      component: Feenew,
	  meta: {
		keepAlive: true,

      }
    },
	{
      path: '/subjectlist',
      name: 'Subjectlist',
      component: Subjectlist
    },
	{
      path: '/result',
      name: 'Result',
      component: Result
    },
	{
      path: '/subjectlistresult',
      name: 'Subjectlistresult',
      component: Subjectlistresult
    },
	{
      path: '/vip',
      name: 'Vip',
      component: Vip
    },
	{
      path: '/corder',
      name: 'Corder',
      component: Corder
    },
	{
      path: '/videodetail',
      name: 'Videodetail',
      component: Videodetail
    },
	{
      path: '/poster',
      name: 'Poster',
      component: Poster
    },
	{
      path: '/yuyue',
      name: 'Yuyue',
      component: Yuyue
    },
	{
      path: '/news',
      name: 'News',
      component: News,
	  meta: {
        keepAlive: true,
		showNav:true
      }
    },
	{
      path: '/prize',
      name: 'Prize',
      component: Prize
    },
	{
      path: '/newsinfo',
      name: 'Newsinfo',
      component: Newsinfo
    },
	{
      path: '/paiche',
      name: 'Paiche',
      component: Paiche
    },
	{
      path: '/posterset',
      name: 'Posterset',
      component: Posterset
    },
	{
      path: '/posterdown',
      name: 'Posterdown',
      component: Posterdown
    },
	{
      path: '/addprize',
      name: 'Addprize',
      component: Addprize
    },
	{
      path: '/videovip',
      name: 'Videovip',
      component: Videovip
    },
	{
      path: '/payresult',
      name: 'Payresult',
      component: Payresult
    },
	{
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
	{
      path: '/dg',
      name: 'Dg',
      component: Dg
    },
	{
      path: '/prizelist',
      name: 'Prizelist',
      component: Prizelist
    },
	{
      path: '/prizeuser',
      name: 'Prizeuser',
      component: Prizeuser
    },
	{
      path: '/prizeinfo',
      name: 'Prizeinfo',
      component: Prizeinfo
    },
	{
      path: '/ds',
      name: 'Ds',
      component: Ds
    },
	{
      path: '/dgpay',
      name: 'Dgpay',
      component: Dgpay
    },
	{
      path: '/video',
      name: 'Video',
      component: Video
    },
	{
	  path: '/video1',
	  name: 'Video1',
	  component: Video1
	},
    {
      path:'/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path:'/share',
      name:'Share',
      component:Share
    },
    {
      path:'/bindinginfo',
      name:'Bindinginfo',
      component:Bindinginfo
    },
	{
		path:'/process',
		name:'Process',
		component:Process
	},
	{
		path:'/videocourse',
		name:'Videocourse',
		component:Videocourse
	},
	{
		path:'/integral',
		name:'Integral',
		component:Integral
	},
  {
    path: '/detailjx',
    name: 'Detailjx',
    component: Detailjx
  },
  {
    path: '/contractschool',
    name: 'Contractschool',
    component: Contractschool
  },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/shopdetail',
      name: 'Shopdetail',
      component: Shopdetail
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js